export default __webpack_public_path__ + "static/SRUS RT240 - Product Specifications & Technical Data-43fb68e4476d77217c34215a28e09d84.pdf";